import React, { useContext, useMemo } from 'react';
import {
  EditSceneModalStateContextType,
  EditSceneModalStateProviderProps,
} from './types';

const EditSceneModalStateContext = React.createContext<
  EditSceneModalStateContextType | undefined
>(undefined);

export const EditSceneModalStateProvider: React.FC<EditSceneModalStateProviderProps> = ({
  children,
  dispatch,
  state,
}) => {
  return (
    <EditSceneModalStateContext.Provider
      value={useMemo(() => ({ state, dispatch }), [state, dispatch])}
    >
      {children}
    </EditSceneModalStateContext.Provider>
  );
};

export const useEditSceneModalStateContext = () => {
  const context = useContext(EditSceneModalStateContext);
  if (!context) {
    throw new Error(
      'useEditSceneModalStateContext must be used within a EditSceneModalStateProvider',
    );
  }
  return context;
};
